import React from 'react'
import { sendEmail } from 'utils/emailInfo'

import { PricingCardProps } from './PricingCard.props'

import {
  PricingCardContainer,
  PricingCardHeader,
  PricingCardInfo,
  PricingCardPrice,
  PricingCardPeriod,
  PricingCardFeatures,
  PricingCardFeature,
  PricingCardFooter,
  PricingCardButton,
} from './PricingCard.styled'

const PricingCard = ({
  name,
  price,
  period,
  recomended,
  features,
  importanText,
}: PricingCardProps) => {
  const periodForEmail = period === 'year' ? 'Yearly' : 'Monthly'
  
  return (
    <PricingCardContainer recomended={recomended}>
      <PricingCardHeader>{name}</PricingCardHeader>
      <PricingCardInfo>
        <PricingCardPrice>
          ${price}
          <PricingCardPeriod>/{period}</PricingCardPeriod>
        </PricingCardPrice>
        <PricingCardFeatures importanText={importanText || 0}>
          {features &&
            features.map((feature: string, index) => (
              <PricingCardFeature key={index}>{feature}</PricingCardFeature>
            ))}
        </PricingCardFeatures>
      </PricingCardInfo>
      <PricingCardFooter>
        <PricingCardButton recomended={recomended} onClick={() => sendEmail(periodForEmail, name)}>
          Get started today
        </PricingCardButton>
      </PricingCardFooter>
    </PricingCardContainer>
  )
}

export default PricingCard
